import { render, staticRenderFns } from "./vahanewyear.vue?vue&type=template&id=74e81b4c&scoped=true&"
import script from "./vahanewyear.vue?vue&type=script&lang=js&"
export * from "./vahanewyear.vue?vue&type=script&lang=js&"
import style0 from "./vahanewyear.vue?vue&type=style&index=0&id=74e81b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e81b4c",
  null
  
)

export default component.exports